/* global axios */
import ApiClient from '../ApiClient';

class WgptAutomationsAPI extends ApiClient {
  constructor() {
    super('automations', {
      accountScoped: true,
      wgpt: true,
    });
  }

  list() {
    return axios.get(`${this.url}/list`);
  }

  clone(automationId) {
    return axios.post(`${this.url}/${automationId}/clone`);
  }

  addFile(automationId, data) {
    return axios.post(`${this.url}/${automationId}/files`, data);
  }

  async export(automationId) {
    const { data, headers } = await axios.get(
      `${this.url}/${automationId}/export`,
      {
        responseType: 'blob',
      }
    );

    let filename = 'automation_export.zip';
    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      );
      if (filenameMatch) {
        filename = decodeURIComponent(filenameMatch[1]);
      }
    }

    const file = new File([data], filename, { type: 'application/zip' });

    return { data: file };
  }

  import(data) {
    return axios.post(`${this.url}/import`, data);
  }
}

export default new WgptAutomationsAPI();
